import React from "react";
import { Navigate } from "react-router-dom";
import { useIsServiceEnabled, useServices } from "../context/ServicesContext";
import { Lock } from "lucide-react";

/**
 * Wraps a public route so the user cannot reach it if admin disabled
 * the corresponding service. Redirects to /dashboard with a flash flag.
 */
export default function ServiceGuard({ serviceId, children }) {
  const { loading } = useServices();
  const ok = useIsServiceEnabled(serviceId);

  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="w-6 h-6 border-2 border-[#00E5FF] border-t-transparent animate-spin" />
      </div>
    );
  }
  if (!ok) {
    try {
      sessionStorage.setItem("service_blocked", serviceId);
    } catch (err) {
      // sessionStorage may be unavailable (private mode, embedded webview);
      // not fatal — the user is still redirected.
      console.warn("ServiceGuard: sessionStorage write failed", err);
    }
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}

export function ServiceDisabledBanner() {
  return (
    <div className="m-10 p-6 border border-white/10 rounded bg-[#0A0E17] flex items-center gap-4">
      <Lock className="text-white/40" />
      <div>
        <div className="font-bold text-white">Servizio non disponibile</div>
        <div className="text-white/50 text-sm">
          Questa sezione è temporaneamente disattivata.
        </div>
      </div>
    </div>
  );
}
